/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Privacy_ShortInputs */

const es_footer_privacy_short = /** @type {(inputs: Footer_Privacy_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacidad`)
};

const gl_footer_privacy_short = /** @type {(inputs: Footer_Privacy_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacidade`)
};

const en_footer_privacy_short = /** @type {(inputs: Footer_Privacy_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy`)
};

/**
* | output |
* | --- |
* | "Privacy" |
*
* @param {Footer_Privacy_ShortInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const footer_privacy_short = /** @type {((inputs?: Footer_Privacy_ShortInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Privacy_ShortInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_footer_privacy_short(inputs)
	if (locale === "en") return en_footer_privacy_short(inputs)
	return es_footer_privacy_short(inputs)
});